function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#616161;stroke:#616161;stroke-miterlimit:10;}\n\t.st1{fill:#616161;}\n\t.st2{fill:#FDFEFF;}\n\t.st3{fill:none;stroke:#616161;stroke-miterlimit:10;}\n\t.st4{fill:#616161;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{display:none;fill:#FFFFFF;}\n\t.st7{display:none;fill:#616161;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st8{fill:#BDBDBD;}\n\t.st9{fill:none;stroke:#616161;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_2"
}, React.createElement("g", {
  id: "staking_1_"
}, React.createElement("path", {
  className: "st8",
  d: "M24.02,7.66l-4.54,17.73H40.9V7.66H24.02z M37.66,22.76H23.38l3.25-12.47h11.04V22.76z"
}), React.createElement("path", {
  className: "st8",
  d: "M19.16,28.34c3.23,0,5.84,2.65,5.84,5.91c0,0.11-0.01,0.22-0.02,0.33h7.17c-0.01-0.11-0.02-0.22-0.02-0.33 c0-3.26,2.62-5.91,5.84-5.91c2.56,0,4.73,1.67,5.52,3.98V26.7H16.23v2.44C17.09,28.63,18.09,28.34,19.16,28.34z"
}), React.createElement("path", {
  className: "st8",
  d: "M18.83,29.65c-2.69,0-4.87,2.2-4.87,4.92s2.18,4.92,4.87,4.92s4.87-2.2,4.87-4.92S21.52,29.65,18.83,29.65z  M18.83,36.87c-1.25,0-2.27-1.03-2.27-2.3s1.02-2.3,2.27-2.3c1.25,0,2.27,1.03,2.27,2.3S20.09,36.87,18.83,36.87z"
}), React.createElement("path", {
  className: "st8",
  d: "M38.31,29.65c-2.69,0-4.87,2.2-4.87,4.92s2.18,4.92,4.87,4.92s4.87-2.2,4.87-4.92S41,29.65,38.31,29.65z  M38.31,36.87c-1.25,0-2.27-1.03-2.27-2.3s1.02-2.3,2.27-2.3s2.27,1.03,2.27,2.3S39.56,36.87,38.31,36.87z"
}), React.createElement("rect", {
  x: 15.26,
  y: 7.73,
  className: "st8",
  width: 2.6,
  height: 17.32
}), React.createElement("polygon", {
  className: "st8",
  points: "14.91,29 14.91,27.03 2.81,27.03 0.5,29  "
}), React.createElement("path", {
  className: "st8",
  d: "M3.68,15.87v9.19h9.74v-9.19H3.68z M12.12,23.74H4.98v-6.56h2.49v1.31h2.6v-1.31h2.06V23.74z"
})));

var SvgConsolidado = function SvgConsolidado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConsolidado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consolidado.4bda59e5.svg";
export { ForwardRef as ReactComponent };